module.exports = __webpack_public_path__ + "img/motorway_9x1_z16.14917989.svg";